export default "/images/vendor/flag-icon-css/flags/1x1/dj.svg?278a5a5fce9a6090ce80ad1fc1eaf1fc";